/*
 * Vieux: keep variant-driven blocks (numbered pieces, specifications) in step
 * with the selected variant. Ported from Liive (4060637, 21d9652, b871eb3).
 *
 * On a product page the variant picker only morphs itself, then dispatches
 * `variant:update` (bubbling; Atelier's ThemeEvents.variantUpdate) with the
 * freshly rendered page in event.detail.data.html. Any element marked
 * [data-vieux-refresh="<key>"] takes its contents and `hidden` state from the
 * element with the same key in that response (Liive's older
 * [data-vieux-variant-refresh] + id form still works). Events from other
 * products (cards, quick add) are ignored by product id. After a swap it
 * dispatches vieux:variant-refreshed (bubbling, detail.element) so
 * assets/vieux-dims.js can re-measure the new photo. When the whole <main> is
 * morphed (combined listings) the blocks are already fresh and nothing here
 * is needed. The story Close plate's figure ([data-vieux-close-figure], in
 * its own section) then follows the run line's data-vieux-run value, so it
 * always shows the selected colour's numbered pieces.
 */
if (!window.__vieuxVariantRefresh) {
  window.__vieuxVariantRefresh = true;

  /** @param {Document} html @param {HTMLElement} element */
  const findFresh = (html, element) => {
    const key = element.getAttribute('data-vieux-refresh');
    if (key) return html.querySelector(`[data-vieux-refresh="${CSS.escape(key)}"]`);
    if (element.id) return html.getElementById(element.id);
    return null;
  };

  document.addEventListener('variant:update', (event) => {
    const detail = /** @type {any} */ (event).detail;
    const html = detail?.data?.html;
    if (!html || typeof html.querySelector !== 'function') return;

    const productId = detail?.data?.productId ? String(detail.data.productId) : '';

    document.querySelectorAll('[data-vieux-refresh], [data-vieux-variant-refresh]').forEach((element) => {
      if (!(element instanceof HTMLElement)) return;
      if (productId && element.dataset.productId && element.dataset.productId !== productId) return;

      const fresh = findFresh(html, element);
      if (!fresh) return;

      element.innerHTML = fresh.innerHTML;
      element.hidden = fresh.hasAttribute('hidden');
      for (const attr of Array.from(element.attributes)) {
        if (attr.name.startsWith('data-vieux-') && !fresh.hasAttribute(attr.name)) {
          element.removeAttribute(attr.name);
        }
      }
      for (const attr of Array.from(fresh.attributes)) {
        if (
          attr.name.startsWith('data-vieux-') &&
          attr.name !== 'data-vieux-variant-refresh' &&
          attr.name !== 'data-vieux-refresh'
        ) {
          element.setAttribute(attr.name, attr.value);
        }
      }
      element.dispatchEvent(new CustomEvent('vieux:variant-refreshed', { bubbles: true, detail: { element } }));
    });

    // The Close plate's figure sits in another section, outside the response the picker
    // renders, so it mirrors the run line's value instead of being swapped (story sections).
    const runWrap = document.querySelector(
      productId ? `.vx-run-wrap[data-product-id="${CSS.escape(productId)}"]` : '.vx-run-wrap'
    );
    if (runWrap instanceof HTMLElement) {
      const n = Number.parseInt(runWrap.getAttribute('data-vieux-run') ?? '', 10);
      document.querySelectorAll('[data-vieux-close-figure]').forEach((fig) => {
        if (!(fig instanceof HTMLElement)) return;
        if (productId && fig.dataset.productId && fig.dataset.productId !== productId) return;
        const num = fig.querySelector('.vx-close__num');
        const unit = fig.querySelector('.vx-close__unit');
        const ok = Number.isInteger(n) && n > 0;
        if (num) num.textContent = ok ? String(n) : '';
        if (unit) unit.textContent = n === 1 ? 'numbered piece' : 'numbered pieces';
        fig.hidden = !ok;
      });
    }
  });
}
